import { usePlayerStore, useChipSetStore, GrayBackground, Image, formatToCommaWithLang, toCommaOptions, Button, soundManager, SoundType, useFeatureToggleStore, FeatureToggleType, t } from '@slot-nx/core'
import { TextStyle } from 'pixi.js'
import { Container, Text } from '@pixi/react'
import { getPayStake } from '../../domain/buybonus/util/buyBonusUtil'
import { FreeGameType } from '../../domain/buybonus/enum/buyBonusEnum'
import { gameConfig } from '../../config'

import { usePopupStore } from '../../domain/store/popupStore'
import { useGameStore } from '../../domain/game/store/GameStore'

const textCurrencyStyle = new TextStyle({
  fontSize: 30,
  fill: '#631F58',
  align: 'center',
  fontWeight: '700',
})

const textPayoutStyle = new TextStyle({
  fontSize: 36,
  fill: '#fff',
  align: 'center',
  fontWeight: '700',
})

const textStakeStyle = new TextStyle({
  fontSize: 40,
  fill: '#FFFFFF',
  align: 'center',
  fontWeight: 'bold',
})

const heavenlyBuyStyle = new TextStyle({
  fontSize: 40,
  fill: 'rgb(141 45 22)',
  align: 'center',
  fontWeight: '800',
})

const yummyBuyStyle = new TextStyle({
  fontSize: 40,
  fill: 'rgb(140 36 79)',
  align: 'center',
  fontWeight: '800',
})

export const BuyBonusPopup = () => {
  const isOpenFreeGamePopup = usePopupStore(x => x.isOpenFreeGamePopup)
  const currency = usePlayerStore(x => x.currency)

  const [currentIndex, chipSet] = useChipSetStore(x => [x.currentIndex, x.chipSet])

  const featureToggle = useFeatureToggleStore(x => x.toggleList)
  const isDisableCurrencyDisplay = !featureToggle.get(FeatureToggleType.disableCurrencyDisplay)

  return isOpenFreeGamePopup
    ? (
        <GrayBackground name="BuyBonusPopup">
          <Container x={gameConfig.resolution.width / 2} y={gameConfig.resolution.height / 2 - 200}>
            <Image name="imageBoxBG" image="imageBoxBGDefault" x={0} y={0} anchor={0.5} />
            <Button
              name="CloseButton"
              x={330}
              y={-360}
              enabled={true}
              visible={true}
              width={77}
              height={80}
              defaultView="btnCloseNormal"
              hoverView="btnCloseHover"
              disabledView="btnCloseDisabled"
              pressedView="btnClosePress"
              onPress={() => {
                usePopupStore.setState({
                  isOpenFreeGamePopup: false,
                })
                useGameStore.setState({
                  currentFreeGameType: FreeGameType.MainGame,
                })
              }}
            />
            <Image
              name="Frame"
              image="frame"
              x={0}
              y={430}
              anchor={0.5}
              width={385}
              height={73}
            />
            <Button
              name="MinusButton"
              defaultView="btnMinusNormal"
              hoverView="btnMinusHover"
              disabledView="btnMinusDisabled"
              pressedView="btnMinusPress"
              enabled={currentIndex > 0}
              x={-190}
              y={393}
              width={72}
              height={72}
              onPress={() => {
                soundManager.play(SoundType.stake_minus)
                useChipSetStore.setState({
                  currentIndex: currentIndex === 0 ? currentIndex : currentIndex - 1,
                })
              }}
            />
            <Button
              name="plus button"
              defaultView="btnPlusNormal"
              hoverView="btnPlusHover"
              disabledView="btnPlusDisabled"
              pressedView="btnPlusPress"
              enabled={currentIndex < chipSet.length - 1}
              x={119}
              y={393}
              width={72}
              height={72}
              onPress={() => {
                soundManager.play(SoundType.stake_plus)
                useChipSetStore.setState({
                  currentIndex: currentIndex === chipSet.length - 1 ? currentIndex : currentIndex + 1,
                })
              }}
            />

            <Button
              name="YummyButton"
              x={-357}
              y={-130}
              enabled={true}
              visible={true}
              width={327}
              height={465}
              defaultView="btnFGAlockNormal"
              hoverView="btnFGAlockHover"
              disabledView="btnFGAlockDisabled"
              pressedView="btnFGAlockPress"
              onPress={() => {
                soundManager.play(SoundType.buttonConfirm)
                useGameStore.setState({
                  currentFreeGameType: FreeGameType.YummyFreeGame,
                })

                usePopupStore.setState({
                  isOpenFreeGamePopup: false,
                  isOpenFreeGameConfirmPopup: true,
                })
              }}
            />

            <Button
              name="HeavenlyType"
              x={30}
              y={-130}
              enabled={true}
              visible={true}
              width={327}
              height={465}
              defaultView="btnFGBlockNormal"
              hoverView="btnFGBlockHover"
              disabledView="btnFGBlockDisabled"
              pressedView="btnFGBlockPress"
              onPress={() => {
                soundManager.play(SoundType.buttonConfirm)
                useGameStore.setState({
                  currentFreeGameType: FreeGameType.HeavenlyFreeGame,
                })

                usePopupStore.setState({
                  isOpenFreeGamePopup: false,
                  isOpenFreeGameConfirmPopup: true,
                })
              }}
            />
            {
              isDisableCurrencyDisplay && (
                <Text
                  name="yummyCurrency"
                  text={currency}
                  x={-310}
                  y={190}
                  anchor={0}
                  style={textCurrencyStyle}
                />
              )
            }

            <Text
              name="yummyPayout"
              text={formatToCommaWithLang(getPayStake(
                chipSet[currentIndex],
                FreeGameType.YummyFreeGame,
              ), navigator.language, toCommaOptions.maximumTwoDecimalPlaces)}
              x={isDisableCurrencyDisplay ? -75 : -190}
              y={185}
              anchor={isDisableCurrencyDisplay ? [1, 0] : [0.5, 0]}
              style={textPayoutStyle}
            />
            {
              isDisableCurrencyDisplay && (
                <Text
                  name="heavenlyCurrency"
                  text={currency}
                  x={80}
                  y={190}
                  anchor={0}
                  style={textCurrencyStyle}
                />
              )
            }

            <Text
              name="heavenlyPayout"
              text={formatToCommaWithLang(getPayStake(
                chipSet[currentIndex],
                FreeGameType.HeavenlyFreeGame,
              ), navigator.language, toCommaOptions.maximumTwoDecimalPlaces)}
              x={isDisableCurrencyDisplay ? 315 : 190}
              y={185}
              anchor={isDisableCurrencyDisplay ? [1, 0] : [0.5, 0]}
              style={textPayoutStyle}
            />

            <Text
              name="stake"
              text={formatToCommaWithLang(chipSet[currentIndex], navigator.language, toCommaOptions.maximumTwoDecimalPlaces)}
              x={0}
              y={405}
              anchor={[0.5, 0]}
              style={textStakeStyle}
            />
            <Text
              name="yummyBuy"
              text={t('buyFreeSpinConfirm_BigBuyTitle')}
              x={-145}
              y={270}
              anchor={[1, 0]}
              style={yummyBuyStyle}
            />
            <Text
              name="heavenlyBuy"
              text={t('buyFreeSpinConfirm_BigBuyTitle')}
              x={235}
              y={270}
              anchor={[1, 0]}
              style={heavenlyBuyStyle}
            />
          </Container>
        </GrayBackground>
      )
    : null
}
